module.exports = __webpack_public_path__ + "static/media/LU.cde7fba4.png";